
<div class="container mx-auto p-6 max-w-6xl">
  <div class="mb-8 flex justify-between items-center">
    <div>
      <h2 class="text-3xl font-bold text-gray-800 mb-2">Seznam strelcev</h2>
      <p class="text-gray-600">Dodajte, filtrirajte in urejajte strelce</p>
    </div>
    <div class="flex gap-4">
      <button class="bg-blue-500 text-white border-none rounded-lg px-6 py-3 cursor-pointer text-base font-semibold transition-all hover:bg-blue-600 hover:shadow-lg transform hover:-translate-y-0.5 shadow-md" (click)="showAddDialog = true">
        <i class="fas fa-plus mr-2"></i>Dodaj strelca
      </button>
      <button class="bg-blue-500 text-white border-none rounded-lg px-6 py-3 cursor-pointer text-base font-semibold transition-all hover:bg-blue-600 hover:shadow-lg transform hover:-translate-y-0.5 shadow-md" (click)="showFilter = !showFilter">
        <i class="fas fa-filter mr-2"></i>Filtriraj
      </button>
    </div>
  </div>

  <div class="text-center my-8 text-lg text-gray-600 bg-blue-50 p-4 rounded-lg" *ngIf="loading">
    <i class="fas fa-spinner fa-spin mr-2"></i>Nalagam...
  </div>
  <div class="text-white bg-red-500 px-5 py-3 rounded mx-auto w-fit font-bold text-center my-4 shadow-md" *ngIf="error">
    <i class="fas fa-exclamation-triangle mr-2"></i>{{ error }}
  </div>


<ng-container *ngIf="showFilter">
  <div class="dialog-overlay">
    <app-strelci-filter-dialog (apply)="onFilter($event)"></app-strelci-filter-dialog>
  </div>
</ng-container>

<ng-container *ngIf="showAddDialog">
  <div class="dialog-overlay">
    <app-strelci-add-dialog (save)="onAdd($event)" (cancel)="showAddDialog = false"></app-strelci-add-dialog>
  </div>
</ng-container>


  <div class="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden" *ngIf="!loading && strelci.length > 0">
    <table class="w-full border-collapse">
      <thead>
        <tr class="bg-gradient-to-r from-blue-500 to-blue-600">
          <th class="px-6 py-4 text-center text-white font-bold text-sm uppercase tracking-wider">
            <i class="fas fa-hashtag mr-2"></i>ID
          </th>
          <th class="px-6 py-4 text-center text-white font-bold text-sm uppercase tracking-wider">
            <i class="fas fa-user mr-2"></i>Ime in priimek
          </th>
          <th class="px-6 py-4 text-center text-white font-bold text-sm uppercase tracking-wider">
            <i class="fas fa-home mr-2"></i>Ime kluba
          </th>
          <th class="px-6 py-4 text-center text-white font-bold text-sm uppercase tracking-wider">
            <i class="fas fa-id-card mr-2"></i>Koda kluba
          </th>
          <th class="px-6 py-4 text-center text-white font-bold text-sm uppercase tracking-wider">
            <i class="fas fa-venus-mars mr-2"></i>Spol
          </th>
          <th class="px-6 py-4 text-center text-white font-bold text-sm uppercase tracking-wider">
            <i class="fas fa-cogs mr-2"></i>Akcije
          </th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-200">
        <tr class="hover:bg-blue-50 transition-colors duration-200" *ngFor="let s of strelci">
          <td class="px-6 py-4 text-center text-base font-medium text-gray-900">
            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
              {{ s.member_id }}
            </span>
          </td>
          <td class="px-6 py-4 text-center text-base text-gray-900 font-medium">{{ s.full_name }}</td>
          <td class="px-6 py-4 text-center text-base text-gray-700">{{ s.name }}</td>
          <td class="px-6 py-4 text-center text-base text-gray-700">{{ s.code }}</td>
          <td class="px-6 py-4 text-center text-base text-gray-700">{{ s.gender }}</td>
          <td style="display: none;">{{ s.club_id }}</td>
          <td class="px-6 py-4 text-center">
            <button class="bg-blue-500 text-white border-none rounded-lg px-4 py-2 cursor-pointer text-sm font-medium transition-all hover:bg-blue-600 hover:shadow-md transform hover:-translate-y-0.5" (click)="onEdit(s)">
              <i class="fas fa-edit mr-1"></i>Uredi
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="text-center my-12 bg-gray-50 p-8 rounded-xl border-2 border-dashed border-gray-300" *ngIf="!loading && strelci.length === 0">
    <i class="fas fa-users text-gray-400 text-4xl mb-4"></i>
    <h3 class="text-xl font-semibold text-gray-600 mb-2">Ni strelcev</h3>
    <p class="text-gray-500 mb-4">Dodajte prvega strelca za začetek</p>
    <button class="bg-blue-500 text-white border-none rounded-lg px-6 py-3 cursor-pointer text-base font-semibold transition-all hover:bg-blue-600 hover:shadow-lg transform hover:-translate-y-0.5" (click)="showAddDialog = true">
      <i class="fas fa-plus mr-2"></i>Dodaj strelca
    </button>
  </div>

<ng-container *ngIf="showEditDialog">
  <div class="dialog-overlay">
    <app-strelci-add-dialog
      [strelci]="editStrelec"
      [isEditMode]="true"
      (save)="onEditSave($event)"
      (cancel)="showEditDialog = false">
    </app-strelci-add-dialog>
  </div>
</ng-container>